// i18n area 'common' — locale es-MX (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da common.es-ES.ts e sovrascrive SOLO le chiavi
// che il messicano scrive davvero in un altro modo.
// DA RIVEDERE DA MADRELINGUA: il delta è volutamente STRETTO — il corpus è
// tecnico e le due varianti coincidono quasi ovunque (nessun 'ordenador',
// nessun 'disco duro' divergente, forme di cortesia già in 'usted').
// Sidecar anti-stantie: ../meta/common.es-MX.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './common'

export const esMX: DeepPartial<typeof enUS> = {
  stub: {
    sectionSummary_catalogs: 'El hogar de los artefactos de archivo del clúster: imágenes ISO, templates CT y VM y archivos OCI, organizados en catálogos.'
  }
}
